const productsEndpoint =
  process.env.GATSBY_PRODUCTS_ENDPOINT ||
  "https://qa.shop.trimble.com/api/products-service/v1"
const accountsEndpoint =
  process.env.GATSBY_ACCOUNTS_ENDPOINT ||
  "https://qa.shop.trimble.com/api/accounts-service/v1"
const checkoutBaseUrl =
  process.env.GATSBY_CHECKOUT_BASE_URL ||
  "https://qa.shop.trimble.com"

export { productsEndpoint, accountsEndpoint, checkoutBaseUrl }
